import ShareBar, { ShareWrapper } from "PFApp/components/activity_share/share_bar";
import CardTx from "PFApp/components/card_tx/card_tx";
import { useProfilePreview } from "PFApp/use_profile_preview";
import FreemasonryLayout from "PFComponents/freemasonry/freemasonry_layout";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { activityResponseShapePropType } from "PFCore/base/prop_types/activities_response_prop_types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import css from "./content.less";

const Content = ({ tasks, fetchActivities, tab, handleEditPost, isSideBarVisible, isOneColumn }) => {
  const { t } = useTranslation("feed");

  const { showPreview } = useProfilePreview();

  const [activitiesToShare, setActivitiesToShare] = useState([]);

  const onPageChange = (newPage) => fetchActivities(newPage, tasks.meta.perPage, tab);
  const hasContent = tasks.entries.length > 0;

  const handleShare = (id) =>
    setActivitiesToShare(
      activitiesToShare.includes(id)
        ? activitiesToShare.filter((roleId) => roleId !== id)
        : activitiesToShare.concat(id)
    );

  return (
    <>
      {hasContent ? (
        <div>
          <ShareBar
            activityIds={activitiesToShare}
            onCancel={() => setActivitiesToShare([])}
            style={{ width: isSideBarVisible && !isOneColumn ? "calc(100vw - 400px)" : "100vw" }}
          />
          <FreemasonryLayout minColumnWidth={320}>
            {tasks &&
              tasks.entries.map((task) => (
                <ShareWrapper
                  key={task.id}
                  activitiesToShare={activitiesToShare}
                  onShare={handleShare}
                  activityId={task.id}
                  disabled={task.activity.state === "draft"}
                >
                  <CardTx
                    key={task.id}
                    task={task.activity}
                    isFeed
                    handleEditPost={handleEditPost}
                    handleHeaderClick={() => showPreview({ id: task.profile.id, profile: task.profile })}
                    onShare={handleShare}
                    handleRefetchActivities={() => onPageChange(tasks.meta.page)}
                  />
                </ShareWrapper>
              ))}
          </FreemasonryLayout>
          <SimplePagination
            currentPage={tasks.meta.page}
            totalPages={tasks.meta.totalPages}
            handleClick={onPageChange}
          />
        </div>
      ) : (
        <div className={css.noPages}>
          <div className={css.title}>{t("noLiveActivities")}</div>
          <div className={css.description}>
            <Trans
              i18nKey="createActivityDescription"
              t={t}
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              components={[<a key="0" href="/#search/new/matches/" />]}
            />
          </div>
        </div>
      )}
    </>
  );
};

Content.propTypes = {
  tasks: PropTypes.shape({
    entries: PropTypes.arrayOf(activityResponseShapePropType),
    meta: PropTypes.shape({
      total: PropTypes.number,
      totalPages: PropTypes.number,
      perPage: PropTypes.number,
      page: PropTypes.number
    })
  }),
  fetchActivities: PropTypes.func,
  tab: PropTypes.string,
  handleEditPost: PropTypes.func,
  isSideBarVisible: PropTypes.bool,
  isOneColumn: PropTypes.bool
};

export default Content;
